import type { ComponentProps } from 'react';
import { Button as AriaButton } from 'react-aria-components';
import { cx } from '#core/gen/css';
import { styled } from '#core/gen/jsx';

import styles from './IconButton.module.css';

const BaseButton = styled(AriaButton, {
  base: {
    border: 'none',
    background: 'transparent',
    cursor: 'pointer'
  }
});

type Props = Omit<ComponentProps<typeof BaseButton>, 'className'> & {
  className?: string;
};

export const IconButton = ({ className, ...props }: Props) => {
  return <BaseButton className={cx(styles.iconButton, className)} {...props} />;
};
